<template>
    <div>
        <div class="sidebar-logo-container" style="position: relative;cursor: pointer;">
            <div class="sidebar-title" style="white-space: nowrap">
                <img src="/images/articleHeadLogo.png" style="margin-right: 10px;width: 44px;" />
                <span v-text-lbl="'dcdb.dbgl'">{{ formTitle }}</span>
            </div>
            <div class="sidebar-divide" />
            <div class="sidebar_title_project">{{ title }}</div>
            <div class="right-btn" style="position: absolute;right: 20px;">
                <el-button @click="close()">
                    <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
                    关闭
                </el-button>
            </div>
        </div>
        <div v-if="data.dbList&&data.dbList.length>0" style="display: flex;height: 40px;line-height: 40px;background: #f5f5f5;padding: 0 20px;font-size: 14px;color: #666666;cursor: pointer;">
            <div style="width: 200px;">督办来源：{{ data.dbList[0].basicData.dbSource }}</div>
            <div style="width: 200px;">督办类型：{{ data.dbList[0].basicData.dbType }}</div>
            <div style="width: 200px;">督办模式：{{ dbModeFn(data.dbList[0].basicData.dbMode) }}</div>
            <div style="width: 200px;">督办人：{{ data.dbList[0].basicData.dbMater }}</div>
            <div style="width: 200px;">完成时限：{{ $moment(data.dbList[0].basicData.overDate).format('YYYY-MM-DD') }}</div>
            <div style="width: 200px;">当前节点：{{ data.dbList[0].basicData.dbSource }}</div>
        </div>
        <div
        v-loading="loading"
            class="zoom-container"
            @wheel.prevent="handleWheel"
            @mousedown="handleMouseDown"
            @mousemove="handleMouseMove"
            @mouseup="handleMouseUp"
            @mouseleave="handleMouseUp"
        >
            <div class="viewBox" :style="viewBoxStyle">
                <div v-if="data.gw" class="viewColumn">
                    <div class="viewCard">
                        <div style="display: flex;margin-bottom: 10px;">
                        <div>
                            <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_fwgl.png" alt="">
                        </div>
                        <div class="viewCardTitle">发文管理</div>
                        </div>
                        <div class="viewCardTime">
                        <div style="width: 70px;">单位发文</div>
                        <div style="color: #999999;">创建于：2025-02-26</div>
                        </div>
                        <div class="viewCardContent">
                        <div style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">后倾相关保障人员名单拟定</div>
                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">发起人：黄芳</div>
                        </div>
                        <div class="line_right">
                        <i class="el-icon-caret-right line_right_jt"></i>
                        </div>
                    </div>
                </div>
                <div v-if="data.hy" class="viewColumn">
                    <div style="height: auto;" class="viewCard">
                        <div style="display: flex;margin-bottom: 10px;">
                        <div>
                            <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_hygl.png" alt="">
                        </div>
                        <div class="viewCardTitle">会议管理</div>
                        </div>
                        <template v-for="(hy, hyIdx) in data.hy">
                            <div v-if="hy.module==='ytjy'" :key="hyIdx" style="padding-bottom: 20px;border-bottom: 1px solid #e4e4e4;margin-bottom: 20px;" @click="ytjyClick(hy)">
                                <div class="viewCardTime">
                                    <div style="width: 70px;">{{ hy.moduleName }}</div>
                                    <div style="color: #999999;">创建于：{{ hy.createTime }}</div>
                                </div>
                                <div class="viewCardContent">
                                    <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ hy.flSubject }}</div>
                                    <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">发起人：黄芳</div>
                                </div>
                            </div>
                            <div v-if="hy.module==='hyap'" :key="hyIdx" style="padding-bottom: 20px;border-bottom: 1px solid #e4e4e4;margin-bottom: 20px;">
                                <div class="viewCardTime">
                                    <div style="width: 70px;">{{ hy.moduleName }}</div>
                                    <div style="color: #999999;">发布：{{ hy.createTime }}</div>
                                </div>
                                <div class="viewCardContent">
                                    <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ hy.flSubject }}</div>
                                    <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ hy.content }}</div>
                                    <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">发布人：黄芳</div>
                                </div>
                            </div>
                            <div v-if="hy.module==='jyap'" :key="hyIdx" @click="jyapClick(hy)">
                                <div class="viewCardTime">
                                    <div style="width: 70px;">{{ hy.moduleName }}</div>
                                    <div style="color: #999999;">发布：{{ hy.createTime }}</div>
                                </div>
                                <div class="viewCardContent">
                                    <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ hy.flSubject }}</div>
                                    <div style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ hy.content }}</div>
                                    <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">发布人：黄芳</div>
                                </div>
                            </div>
                        </template>
                        <div class="line_right" style="top: 96px;">
                            <i class="el-icon-caret-right line_right_jt"></i>
                        </div>
                    </div>
                </div>
                <div class="viewColumn">
                    <div v-for="(item,index) in data.dbList" :key="index" style="display: flex;position: relative;">
                        <div v-if="index>0" :style="{'height':getHeightFn(item,index,data.dbList)}" class="line_left_dbrw">
                            <i class="el-icon-caret-right line_left_dbrw_jt"></i>
                        </div>
                        <div>
                            <div v-if="item.dbrw" class="viewCard">
                                <div style="display: flex;margin-bottom: 10px;">
                                    <div>
                                        <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_rwjb.png" alt="">
                                    </div>
                                    <div class="viewCardTitle">督办任务</div>
                                </div>
                                <div class="viewCardTime">
                                    <div style="width: 70px;">{{ item.dbrw.moduleName }}</div>
                                    <div style="color: #999999;">创建于：{{ item.dbrw.createTime }}</div>
                                </div>
                                <div class="viewCardContent">
                                    <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ item.dbrw.flSubject }}</div>
                                    <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">发起人：{{ item.dbrw.creator }}</div>
                                </div>
                                <!-- <div class="line_right">
                                <i class="el-icon-caret-right line_right_jt"></i>
                                </div> -->
                                <div class="line_bottom">
                                    <i class="el-icon-caret-bottom line_bottom_jt"></i>
                                </div>
                            </div>
                            <div v-if="item.rwjb" class="viewCard" style="height: 306px;">
                                <div style="display: flex;margin-bottom: 10px;">
                                <div>
                                    <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_rwjb.png" alt="">
                                </div>
                                <div class="viewCardTitle">任务交办</div>
                                </div>
                                <div class="viewCardTime">
                                <div style="color: #999999;">交办时间：{{ $moment(item.rwjb.jbTime).format('YYYY-MM-DD') }}</div>
                                </div>
                                <div class="viewCardContent">
                                <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ item.rwjb.flSubject }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">主办部门：{{ item.rwjb.qtDept }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">配合部门：{{ item.rwjb.phDept }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">督办人：{{ item.rwjb.dbMater }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">督办模式：{{ item.rwjb.dbMode }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">开始日期：{{ item.rwjb.startTime }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">完成日期：{{ item.rwjb.entTime }}</div>
                                </div>
                                <!-- 展开/折叠 -->
                                <div class="lookDia" @click="lookDiaFn(item.rwjb,index)">
                                    <i v-if="item.rwjb.children.length>0" class="el-icon-remove"></i>
                                    <i v-else class="el-icon-circle-plus"></i>
                                </div>
                                <div v-if="item.rwjb.children.length>0" style="width: 26px;" class="line_right">
                                <!-- <i v-if="!isDbrwShow" class="el-icon-caret-right line_right_jt"></i> -->
                                </div>
                                <div class="line_bottom">
                                <i class="el-icon-caret-bottom line_bottom_jt"></i>
                                </div>
                            </div>
                            <div v-if="item.rwbj" class="viewCard" @click="dbClick(item.rwbj,4)">
                                <div style="display: flex;margin-bottom: 10px;">
                                <div>
                                    <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_rwbj.png" alt="">
                                </div>
                                <div class="viewCardTitle">任务办结</div>
                                </div>
                                <div class="viewCardTime">
                                <!-- <div style="width: 70px;">{{ item.rwbj.moduleName }}</div> -->
                                <div style="color: #999999;">办结时间：{{ $moment(item.rwbj.bjTime).format('YYYY-MM-DD') }}</div>
                                </div>
                                <div class="viewCardContent">
                                <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ item.rwbj.flSubject }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">办结人：{{ item.rwbj.bjName }}</div>
                                </div>
                                <div class="line_bottom">
                                <i class="el-icon-caret-bottom line_bottom_jt"></i>
                                </div>
                            </div>
                            <div v-if="item.rwgd" class="viewCard" @click="dbClick(item.rwgd,5)">
                                <div style="display: flex;margin-bottom: 10px;">
                                <div>
                                    <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_rwgd.png" alt="">
                                </div>
                                <div class="viewCardTitle">任务归档</div>
                                </div>
                                <div class="viewCardTime">
                                <!-- <div style="width: 70px;">议题上报</div> -->
                                <div style="color: #999999;">归档时间：{{ item.rwgd.bjTime }}</div>
                                </div>
                                <div class="viewCardContent">
                                <div class="ellipsis-one-lines" style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ item.rwgd.flSubject }}</div>
                                <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">归档人：{{ item.rwgd.gdName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="viewColumn">
                            <div v-for="(val,idx) in item.rwjb.children" :key="idx" style="display: flex;height: 356px;">
                                <div class="viewCard" style="height: 228px;" @click="dbClick(val,1)">
                                    <div style="display: flex;margin-bottom: 10px;">
                                        <div>
                                            <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_gzqs.png" alt="">
                                        </div>
                                        <div class="viewCardTitle">工作签收</div>
                                    </div>
                                    <div class="viewCardTime">
                                        <div style="width: 70px;">{{ val.type==1?'主办部门':'配合部门' }}</div>
                                        <div v-if="setTimeFn(val)==1" style="color: #1a82e3;">未签收</div>
                                        <div v-if="setTimeFn(val)==2" style="color: #1a82e3;">超期未签收</div>
                                        <div v-if="val.qsDate" style="color: #999999;">签收于：{{ $moment(val.qsDate).format('YYYY-MM-DD') }} <span v-if="val.qsDate&&val.deptName&&val.qsDate>val.deptName" style="color: red;">（超期）</span></div>
                                    </div>
                                    <div class="viewCardContent">
                                        <div style="font-size: 14px;font-weight: 700;height: 26px;line-height: 25px;">{{ val.deptName }}</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: red;">签收时限：{{ $moment(val.qsLimit).format('YYYY-MM-DD') }}</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">签收人：{{ val.qsUser }}</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">反馈人：{{ val.recUser }}</div>
                                    </div>
                                    <!-- <div class="line_right">
                                        <i class="el-icon-caret-right line_right_jt"></i>
                                    </div> -->
                                    <div v-if="idx==0" :class="item.rwjb.children.length==1?'line_left_top_one':'line_left_top'">
                                        <i class="el-icon-caret-right line_left_top_jt"></i>
                                    </div>
                                    <div v-if="idx>0" class="line_left">
                                        <i class="el-icon-caret-right line_left_jt"></i>
                                    </div>
                                </div>
                                <div v-for="(hb,hbIdx) in val.children" :key="hbIdx" class="viewCard" style="height: 306px;" @click="gzhbClick(hb,hbIdx)">
                                    <div style="display: flex;margin-bottom: 10px;">
                                        <div>
                                            <img style="width: 24px;height: 24px;margin-right: 10px;" src="../../imgs/workflowChart_gzhb.png" alt="">
                                        </div>
                                        <div class="viewCardTitle">工作汇报</div>
                                    </div>
                                    <div class="viewCardTime">
                                        <div style="width: 70px;">{{ hb.type==1?'主办汇报':'配合汇报' }}</div>
                                        <div v-if="setTimeFn1(hb)==4" style="color: #999999;">汇报于： {{ $moment(new Date(hb.hbTime)).format('YYYY-MM-DD') }} </div>
                                        <div v-if="setTimeFn1(hb)==3" style="color: #999999;">汇报于： {{ $moment(new Date(hb.hbTime)).format('YYYY-MM-DD') }} <span style="color: red;">（超期）</span></div>
                                        <div v-if="setTimeFn1(hb)==2" style="color: #999999;">汇报于： <span style="color: red;">（超期未汇报）</span> </div>
                                        <!-- <div v-if="setTimeFn1(hb)==1" style="color: #999999;">汇报于： {{ $moment(new Date(hb.reportDealDate)).format('YYYY-MM-DD') }} </div> -->
                                    </div>
                                    <div class="viewCardContent">
                                        <div v-if="hb.flSubject" class="ellipsis-two-lines" style="font-size: 14px;font-weight: 700;line-height: 25px;">{{ hb.flSubject }}</div>
                                        <div v-if="hb.hbTime" style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">督办（{{ hb.hbTime }}）</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #1a82e3;">任务进度：{{ overStatusFn(hb.overStatus) }}</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">当前情况：{{ hb.execStatusDesc }}</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">存在问题和下步计划：{{ hb.reportContent }}</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">反馈人：{{ val.recUser }}</div>
                                        <div style="font-size: 14px;height: 26px;line-height: 25px;color: #999999;">反馈截止时间：<span style="color: red;">{{ $moment(new Date(hb.reportDealDate)).format('YYYY-MM-DD HH:mm') }}</span></div>
                                    </div>
                                    <div class="line_right_left">
                                        <i class="el-icon-caret-right line_right_left_jt"></i>
                                    </div>
                                    <!-- <div :style="{'border-left':index==0?'0px':'2px dashed #1872d6'}" class="line_left">
                                        <i class="el-icon-caret-right line_left_jt"></i>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <dblxForm />
        <rwcbForm />
        <dbjbForm />
        <rwbjForm />
        <rwgdForm />
    </div>
  </template>

<script>
import dblxForm from './dblxForm.vue'
// import rwcbForm from './rwcbForm.vue'
// import dbjbForm from './dbjbForm.vue'
import rwbjForm from './rwbjForm.vue'
import rwgdForm from './rwgdForm.vue'
export default {
    components: {
        dblxForm,
        // rwcbForm,
        // dbjbForm,
        rwbjForm,
        rwgdForm
    },
    props: {},
    data() {
        return {
            formTitle: '',
            loading: true,
            title: '',
            isDbrwShow: false,
            scale: 1,
            isDragging: false,
            dragStart: { x: 0, y: 0 },
            viewBoxPosition: { x: 0, y: 0 },
            data: {},
            dataVo: {},
            rowId: ''
        }
    },
    computed: {
        viewBoxStyle() {
            return {
                transform: `translate(${this.viewBoxPosition.x}px, ${this.viewBoxPosition.y}px) scale(${this.scale})`,
                //transformOrigin: 'center',
                width: `${100 / this.scale}%`,
                height: `${100 / this.scale}%`
            }
        }
    },
    watch: {},
    created() {
        console.log('===>>>>', this.$route.query.rowId)
        this.rowId = this.$route.query.rowId
        this.formTitle = this.$route.query.formTitle
        this.title = this.$route.query.title
        this.getData()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        dbModeFn(val) {
            let str = ''
            if (val == 0) {
                str = '周督办'
            } else if (val == 1) {
                str = '月度督办'
            } else if (val == 2) {
                str = '季度督办'
            } else if (val == 3) {
                str = '一次督办'
            } else if (val == 4) {
                str = '自定义'
            }
            return str
        },
        overStatusFn(val) {
            let str = ''
            if (val === 0) {
                str = '已完成'
            } else if (val === 1) {
                str = '推进中'
            } else if (val === 2) {
                str = '滞后'
            } else if (val === 3) {
                str = '部分滞后'
            }
            return str
        },
        timeFormat(val) {
            let str = ''
            if (val) {
                str = this.$moment(val).format('YYYY-MM-DD')
            }
            return str
        },
        setTimeFn(val) {
            let type = 0
            let nowTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            let qsLimit = this.$moment(new Date(val.qsLimit)).format('YYYY-MM-DD HH:mm:ss')
            if (!val.qsDate && nowTime < qsLimit) {
                type = 1 //未超期
            } else if (!val.qsDate && nowTime > qsLimit) {
                type = 2 //超期
            }
            return type
        },
        setTimeFn1(val) {
            let type = 0
            let nowTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            let reportDealDate = this.$moment(new Date(val.qsLimit)).format('YYYY-MM-DD HH:mm:ss')
            let hbTime = this.$moment(new Date(val.hbTime)).format('YYYY-MM-DD HH:mm:ss')
            if (!hbTime && nowTime < reportDealDate) {
                type = 1 //未超期
            } else if (!hbTime && nowTime > reportDealDate) {
                type = 2 //超期未汇报
            } else if (hbTime && hbTime > reportDealDate) {
                type = 3 //超期汇报
            } else if (hbTime && hbTime <= reportDealDate) {
                type = 4 //已汇报
            }
            return type
        },
        dbClick(row, type) {
            if (type === 1) {
                this.$bus.emit('openDblxFormDialog', row.matterId)
            } else if (type === 2) {
                this.$bus.emit('openDbjbormDialog', row.id)
            } else if (type === 3) {
                this.$bus.emit('openRwcbFormDialog', row.id)
            } else if (type === 4) {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/dcdb/matter/getDblcb`,
                    method: 'GET',
                    params: { id: row.matterId }
                }).then((res) => {
                    if (res.code === 'success') {
                    // 成功
                        this.$bus.emit('openRwbjFormDialog', res.body.vo)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else if (type === 5) {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/dcdb/matter/getDblcb`,
                    method: 'GET',
                    params: { id: row.matterId }
                }).then((res) => {
                    if (res.code === 'success') {
                    // 成功
                        this.$bus.emit('openRwgdFormDialog', res.body.vo)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        gzhbClick(hb, hbIdx) {
            window.open(`#/wflow?wfEngineUrl=dcdb/report&busiDataId=${hb.id}&orgCode=${this.$store.getters.loginUser.orgCode}`)
        },
        ytjyClick(hy) {
            window.open(`#/wflow?wfEngineUrl=hygl/ytap&busiDataId=${hy.id}&orgCode=${this.$store.getters.loginUser.orgCode}`)
        },
        jyapClick(hy) {
            window.open(`#/wflow?wfEngineUrl=hygl/jyap&busiDataId=${hy.id}&orgCode=${this.$store.getters.loginUser.orgCode}`)
        },
        lookDiaFn(rwjb, index) {
            if (rwjb.children.length > 0) {
                rwjb.children = []
            } else {
                if (this.dataVo.dbList[index].rwjb) {
                    rwjb.children = JSON.parse(JSON.stringify(this.dataVo.dbList[index].rwjb.children))
                } else {
                    rwjb.children = []
                }
            }
        },
        close() {
            window.close()
        },
        getData() {
            let params = { preId: this.rowId }
            if (this.$route.query.formTitle == '督办管理') {
                params = { nextId: this.rowId }
            }
            this.$http({
                method: 'get',
                url: '/dcdb/task/getChart',
                params
            }).then(res => {
                if (res.code === 'success') {
                    console.log('===>res', res)
                    this.dataVo = res.body.data
                    this.data = JSON.parse(JSON.stringify(this.dataVo))
                    this.loading = false
                } else {
                    this.$message({message: res.msg, type: 'error' })
                }
            })
        },
        getHeightFn(item, index, dbList) {
            let str = ''
            if (dbList[index - 1].rwjb.children.length > 3 || (dbList[index - 1].rwjb.children.length == 3 && !dbList[index - 1].dbrw)) {
                str = (356 * dbList[index - 1].rwjb.children.length) + 'px'
            } else {
                let num = 0
                if (dbList[index - 1].dbrw) {
                    num += 250
                }
                if (dbList[index - 1].rwjb) {
                    num += 350
                }
                if (dbList[index - 1].rwbj) {
                    num += 250
                }
                if (dbList[index - 1].rwgd) {
                    num += 250
                }
                if (num < 700 && dbList[index - 1].rwjb.children.length > 1) {
                    str = (356 * dbList[index - 1].rwjb.children.length) + 'px'
                } else {
                    str = num + 'px'
                }
                // if (dbList[index - 1].rwgd) {
                //     str = (356 + 250 + 250) + 'px'
                // } else if (dbList[index - 1].rwbj && !dbList[index - 1].rwgd&&dbList[index - 1].rwjb) {
                //     str = (356 + 250) + 'px'
                // } else {
                //     str = (356) + 'px'
                // }
            }
            return str
            //  else if (dbList[index - 1].dbrw) {
            //     if (dbList[index - 1].rwgd) {
            //         str = (356 + 250 + 250 + 250) + 'px'
            //     } else if (dbList[index - 1].rwbj && !dbList[index - 1].rwgd) {
            //         str = (356 + 250 + 250) + 'px'
            //     } else {
            //         str = (356 + 250) + 'px'
            //     }
            // }
        },
        handleWheel(event) {
            const delta = event.deltaY > 0 ? -0.1 : 0.1
            const newScale = this.scale + delta
            if (newScale > 0.4 && newScale < 2) {
                this.scale = newScale
            }
        },
        handleMouseDown(event) {
            this.isDragging = true
            this.dragStart = { x: event.clientX, y: event.clientY }
            document.body.style.userSelect = 'none' // 禁用文本选择
            document.body.style.cursor = 'grabbing' // 改变鼠标样式为抓取中
        },
        handleMouseMove(event) {
            if (this.isDragging) {
                const dx = event.clientX - this.dragStart.x
                const dy = event.clientY - this.dragStart.y
                this.viewBoxPosition.x += dx
                this.viewBoxPosition.y += dy
                this.dragStart = { x: event.clientX, y: event.clientY }
            }
        },
        handleMouseUp() {
            this.isDragging = false
            document.body.style.userSelect = '' // 恢复文本选择
            document.body.style.cursor = 'grab' // 恢复鼠标样式为抓取
        }
    }
}
</script>

  <style scoped lang="scss">
  .zoom-container {
    width: 100%;
    height: calc(100vh - 108px);
    overflow: hidden;
    position: relative;
    user-select: none; /* 防止文本选择 */
    // cursor: grab; /* 默认抓手样式 */
    background: #f5f5f5;
  }

  .viewBox {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 20px;
    position: absolute;
    top: 0;
    left: 0;
    transition: transform 0.2s ease;
  }

  .viewColumn {
    // margin-right: 80px;
    .viewCard {
      width: 300px;
      height: 200px;
      background: #fff;
      box-shadow: 0 0 7px 4px #00000026;
      border-radius: 6px;
      padding: 20px;
      margin-bottom: 50px;
      position: relative;
      cursor: pointer;
      margin-right: 80px;
      .viewCardTitle {
        font-size: 16px;
        line-height: 28px;
        font-weight: 700;
      }
      .viewCardTime {
        display: flex;
        font-size: 14px;
        height: 22px;
        line-height: 22px;
        margin-bottom: 5px;
      }
      .viewCardContent {
        height: calc(100% - 65px);
        background: #f4f4f4;
        padding: 10px;
      }
    }
  }
  .line_right_left {
    width: 70px;
    height: 0px;
    border-top: 2px dashed #1872d6;
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translate(-100%, -50%);
    .line_right_left_jt {
      position: absolute;
      right: -10px;
      top: 0px;
      transform: translate(2px, -50%);
      color: #1872d6;
    }
  }
  .line_right {
    width: 70px;
    height: 0px;
    border-top: 2px dashed #1872d6;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(100%, -50%);
    .line_right_jt {
      position: absolute;
      right: -10px;
      top: 0px;
      transform: translate(2px, -50%);
      color: #1872d6;
    }
  }
  .line_left_top {
    width: 40px;
    height: 298px;
    border-top: 2px dashed #1872d6;
    border-left: 2px dashed #1872d6;
    border-bottom: 0px;
    position: absolute;
    top: unset;
    left: -11px;
    bottom: -100%;
    transform: translate(-100%, -56px);
    .line_left_top_jt {
        position: absolute;
        right: -13px;
        top: 0px;
        transform: translate(0px, -9px);
        color: #1872d6;
    }
  }
  .line_left_top_one {
    width: 40px;
    height: 0px;
    border-top: 2px dashed #1872d6;
    border-left: 2px dashed #1872d6;
    border-bottom: 0px;
    position: absolute;
    top: unset;
    left: -11px;
    bottom: unset;
    transform: translate(-100%, -56px);
    .line_left_top_jt {
        position: absolute;
        right: -13px;
        top: 0px;
        transform: translate(0px, -9px);
        color: #1872d6;
    }
  }
  .line_left {
    width: 40px;
    height: 356px;
    border-bottom: 2px dashed #1872d6;
    border-left: 2px dashed #1872d6;
    position: absolute;
    top: -100%;
    left: -11px;
    transform: translate(-100%, -25px);
    .line_left_jt {
      position: absolute;
      right: -13px;
      bottom: 0px;
      transform: translate(0px, 9px);
      color: #1872d6;
    }
  }
  .line_bottom {
    width: 0px;
    height: 40px;
    border-left: 2px dashed #1872d6;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 100%);
    .line_bottom_jt {
      position: absolute;
      left: 0px;
      bottom: 0px;
      transform: translate(-55%, 12px);
      color: #1872d6;
    }
  }

  .lookDia {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translate(0px, -8px);
    color: #1872d5;
  }

  .sidebar-logo-container {
        height: 68px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        background: #fff;
        .sidebar-title {
            color: #333;
            font-weight: 400;
            line-height: 35px;
            font-size: 22px;
            align-items: center;
            display: flex;
            svg {
                font-size: 35px;
            }
        }
        .sidebar-divide {
            border-right: 1px solid #ccc;
            margin: 0 10px;
            height: 22px;
        }
        .sidebar_title_project {
            font-size: 16px;
            line-height: 28px;
            height: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #999;
        }
    }
    .line_left_dbrw {
        position: absolute;
        left: -50px;
        top: 100px;
        width: 40px;
        // min-height: 1106px;
        height: calc((356px* 4));
        border-left: 2px dashed #1872d6;
        border-bottom: 2px dashed #1872d6;
        transform: translate(0px, -100%);
        .line_left_dbrw_jt {
            position: absolute;
            right: -10px;
            bottom: -9px;
            color: #1872d5;
        }
    }

    .ellipsis-two-lines {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 限制为两行 */
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .ellipsis-one-lines {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
  </style>
